<div class="flex flex-col items-center justify-center min-h-[calc(100vh-200px)] p-4">
  <div class="bg-white p-8 md:p-12 rounded-2xl shadow-xl max-w-lg w-full text-center border-4 border-[var(--black)]">
    <div class="mb-6">
      <svg class="w-20 h-20 text-red-500 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
    </div>
    <h1 class="text-3xl md:text-4xl font-bold text-[var(--dark-orange)] mb-4">{{ 'paymentError.title' | translate }}</h1>
    <p class="text-gray-700 text-lg mb-8">{{ 'paymentError.desc' | translate }}</p>
    <div class="mt-8">
      <app-button [text]="'paymentError.backHome' | translate" (click)="goToHome()" [styleType]="'primary-flat'" [fullWidth]="true"></app-button>
    </div>
  </div>
</div>
